import React from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet, Navigate } from 'react-router-dom';
import { AuthFooter } from '../auth/AuthFooter';

import { Logo } from '../common/ui/Logo';
import { ToastNotifications } from '../notifications/ToastNotifications';

export const AuthLayout = () => {
    const user = useSelector((state) => state.auth.user);

    if (user !== null) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="auth-page d-flex flex-column align-items-center vh-100 bg-light">
            <main className="auth-page flex-shrink-0 d-flex align-items-center my-auto">
                <div className="auth-form text-center mx-auto">
                    <Link to="/">
                        <Logo size="5x"></Logo>
                    </Link>
                    <Outlet />
                </div>
                <ToastNotifications />
            </main>
            <AuthFooter />
        </div>
    );
};
